import React from 'react';
import { ProductCard } from '../../CategoryPage/ProductCard';

export const ProductRowItem = ({ product }) => {
  return <ProductCard product={product?.value ?? product}></ProductCard>;
};
